import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import BeforeAfter from "./BeforeAfter";

const BEFORE_IMG =
  "/terra.jpeg";
const AFTER_IMG =
  "/terrad.jpg";

const CARDS = [
  {
    img: "https://images.unsplash.com/photo-1520870121499-7dddb6ccbcde?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tag: "MAPEAMENTO AÉREO",
    title: "Voo com drone para fotogrametria do terreno",
  },
  {
    img: "https://images.unsplash.com/photo-1628158088936-68ccaaa400dc?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tag: "LOCAÇÃO EM CAMPO",
    title: "Equipamento de precisão em locação de obra",
  },
  {
    img: "https://images.unsplash.com/photo-1516822277566-bb38424a2b77?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tag: "GEORREFERENCIAMENTO",
    title: "Mapeamento perimetral de imóvel rural",
  },
];

export default function Gallery() {
  return (
    <section id="projetos" className="relative py-24 lg:py-32 bg-deep/40">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.6 }}
              className="font-mono text-xs uppercase tracking-[0.32em] text-dm-contour"
            >
              Projetos
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ delay: 0.1, duration: 0.7 }}
              className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
            >
              A transformação do <span className="text-gradient">terreno</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.25, duration: 0.7 }}
            className="max-w-sm text-sm leading-relaxed text-slate-400"
          >
            Arraste o comparador e veja o resultado do serviço de terraplenagem
            com controle dimensional rigoroso.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
          className="mt-14"
        >
          <BeforeAfter beforeSrc={BEFORE_IMG} afterSrc={AFTER_IMG} />
        </motion.div>

        <div className="mt-6 grid gap-5 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <motion.article
              key={c.tag}
              data-testid={`gallery-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 h-64"
            >
              <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/35 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <p className="font-mono text-[10px] tracking-[0.3em] text-dm-contour">{c.tag}</p>
                <p className="mt-2 flex items-start justify-between gap-3 font-display text-lg font-semibold text-white">
                  {c.title}
                  <ArrowUpRight
                    size={18}
                    className="shrink-0 text-slate-500 transition-all duration-500 group-hover:text-dm-glow group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
